import React from 'react';

import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    height: 78,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.applyOpacityToHex?.(theme.palette.border.light, 0)}`,
    borderBottom: `1px solid ${theme.palette.skeleton.light}`,
  },
  bold: {
    fontWeight: 500,
  },
  light: {
    color: theme.palette.skeleton.dark,
  },
}));

function SkeletonRow({ string1 = '', string2 = '' }) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant='bodyRegular' className={classes.bold}>
        {string1}
      </Typography>
      <Typography variant='paragraphRegular' className={classes.light}>
        {string2}
      </Typography>
    </div>
  );
}

export default SkeletonRow;
